/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { withRouter, useParams, useHistory } from "react-router-dom";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { Button } from "@material-ui/core";
import Page from "components/common_components/Page/Page";
import useStyles from "./useStyles";
import { useDispatch, useSelector } from "react-redux";
import { notifyError } from "redux/actions/Notifications";
import LoadingPage from "components/common_components/LoadingPage";
import InvoicingContext from "./InvoicingContext";
import Header from "components/common_components/Header";
import Report from "./Report";

function List() {
    const classes = useStyles();
    const { user } = useSelector((state) => state.Login);
    const history = useHistory();
    const { id } = useParams();
    const [invoice, setInvoice] = useState(undefined);
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);

    const { Invoices } = useContext(InvoicingContext);

    function getInvoice() {
        setIsLoading(true);
        Invoices.getOneById({
            id,
            onSuccess: (data) => {
                setInvoice(data);
                setIsLoading(false);
            },
            onError: (error) => {
                dispatch(notifyError(error));
                setIsLoading(false);
            },
        });
    }

    useEffect(() => {
        if (id) {
            getInvoice();
        }
    }, [id]);

    function onCancelHandler() {
        history.goBack();
    }

    return (
        <Page className={classes.root}>
            <Header title="Invoice" />
            {isLoading && <LoadingPage />}
            {invoice && !isLoading && (
                <>
                    <div className="button-group">
                        <Button
                            onClick={onCancelHandler}
                            variant="text"
                            size="small"
                            type="reset"
                            color="default"
                            startIcon={<ArrowBackIcon />}
                        >
                            Back
                        </Button>
                    </div>
                    <Report reportProps={{ invoice, currentUser: user }} reportType="invoice" />
                </>
            )}
        </Page>
    );
}

List.propTypes = {
    history: PropTypes.shape({
        replace: PropTypes.func,
        location: PropTypes.shape({
            pathname: PropTypes.string,
        }),
    }).isRequired,
};

export default withRouter(List);
